import { OUTCOMES, STATUSES } from "@/lib/constants";

export const StatusBadge = ({ status, testId }) => {
  const s = STATUSES[status] || { label: status, cls: "" };
  return (
    <span data-testid={testId} className={`status-chip inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
};

export const OutcomeBadge = ({ outcome, testId }) => {
  const s = OUTCOMES[outcome] || { label: outcome, cls: "" };
  return (
    <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>
      {s.label}
    </span>
  );
};
